/* todo: combine */
export enum ProductLandingPageSections {
  SPECIAL_OFFERS = 'hotel__page-section--special-offers',
  PRICES = 'hotel__page-section--prices',
  FACILIIES = 'hotel__page-section--facilities',
  ROOM_TYPES = 'common__label--room-types',
  LOCAL_AREA = 'hotel__page-section--local-area',
  TRIP_ADVISOR_REVIEWS = 'hotel__page-section--trip-advisor-reviews'
}

export enum ProductBookingPageSections {
  SPECIAL_OFFERS = 'hotel__page-section--special-offers',
  PRICES = 'hotel__page-section--prices',
  ROOM_TYPES = 'common__label--room-types',
  FACILIIES = 'hotel__page-section--facilities',
  LOCAL_AREA = 'hotel__page-section--local-area',
  TRIP_ADVISOR_REVIEWS = 'hotel__page-section--trip-advisor-reviews'
}
